import { useState } from "react";
import { MapPin, ForkKnife } from "@phosphor-icons/react";
import { FoodObservatory } from "../components/FoodObservatory";
import { MarketResearch } from "../components/MarketResearch";

const SECTIONS = [
  { id: "mercato", title: "Analisi di mercato", icon: MapPin, color: "#E9A23B", desc: "Concorrenza in zona: mappa, elenco attività e report PDF" },
  { id: "food", title: "Osservatorio Food", icon: ForkKnife, color: "#34D399", desc: "Trend stagionali e idee promo per il mondo food" },
];

export default function AnalisiPage() {
  const [section, setSection] = useState(null);

  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="analisi-page">
      <div className="mb-8 animate-fade-up">
        <p className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2">Il quadro completo</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tighter leading-none">Analisi</h1>
        <p className="text-sm text-slate-400 mt-3">Clicca una card per aprire la sezione corrispondente.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10 animate-fade-up">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          const active = section === s.id;
          return (
            <button key={s.id} type="button" onClick={() => setSection(active ? null : s.id)}
              data-testid={`analisi-section-${s.id}`}
              style={{ "--sec-color": s.color }}
              className={`text-left p-5 rounded-2xl border backdrop-blur-md transition-all duration-300 ${
                active
                  ? "bg-white/[0.07] border-[var(--sec-color)] shadow-[0_10px_36px_-14px_var(--sec-color)]"
                  : "bg-white/[0.03] border-white/10 hover:border-white/25 hover:-translate-y-0.5"
              }`}>
              <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl mb-3"
                style={{ backgroundColor: `${s.color}1A` }}>
                <Icon size={24} weight="duotone" style={{ color: s.color }} />
              </span>
              <h3 className="font-heading text-lg font-semibold tracking-tight" style={active ? { color: s.color } : undefined}>
                {s.title}
              </h3>
              <p className="text-xs text-white/50 mt-1">{s.desc}</p>
            </button>
          );
        })}
      </div>

      {section === "mercato" && <MarketResearch />}

      {section === "food" && <FoodObservatory />}
    </main>
  );
}
